import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <header>
      <nav>
        <h1>शुद्ध ऊर्जा प्रणाली</h1>
        <h2>Shuddh Urja System</h2>
      </nav>
    </header>
    <main>
      <router-outlet></router-outlet>
    </main>
    <footer>
      <p>© 2025 शुद्ध ऊर्जा प्रणाली</p>
    </footer>
  `,
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'शुद्ध ऊर्जा प्रणाली';
}